import cx from 'classnames'
import ReactDOM from 'react-dom'

import type { PictureProps } from './Picture.types'
import classes from './styles.module.scss'
import { generatePictureByType } from './utils/generatePictureByType'

export function PreloadPicture({ href, ...props }: { href: string; imageSrcSet: string; imageSizes: string }): null {
  // the mime type is not supporting for now
  ReactDOM.preload(href, { as: 'image', fetchPriority: 'high', ...props })

  return null
}

export function Picture(props: PictureProps) {
  const { src, alt, className, loading, type, priority, version, isWebpFirst = true } = props
  const { sizes, png, webp, fallback, width, height } = generatePictureByType({
    imageType: type,
    src,
    version,
  })

  return (
    <>
      {priority && !!png.length && <PreloadPicture href={fallback} imageSrcSet={png} imageSizes={sizes} />}
      {priority && !!webp.length && isWebpFirst && (
        <PreloadPicture href={fallback} imageSrcSet={webp} imageSizes={sizes} />
      )}
      <picture>
        {!!png.length && <source srcSet={png} type='image/png' sizes={sizes} />}
        {!!webp.length && isWebpFirst && <source srcSet={webp} type='image/webp' sizes={sizes} />}
        <img
          src={fallback}
          alt={alt}
          className={cx(classes.image, className)}
          width={width}
          height={height}
          loading={!priority ? loading : 'eager'}
          decoding='async'
          fetchPriority={priority ? 'high' : undefined}
        />
      </picture>
    </>
  )
}
